import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

import {
  Grid,
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
  Snackbar,
  Stack,
} from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const LocationFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  open,
  ...props
}) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "location-entry";
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {
                    DispensingLanguage[lan][menukey][
                      "Location Entry Form - Add/Edit"
                    ]
                  }
                </div>

                <div className="float-end sw_btn_control">
                  {addProductForm ? (
                    <Grid item xs={12} className="mt-4 text-center">
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => handleReset()}
                      >
                        {t(DispensingLanguage[lan][menukey]["Reset"])}
                      </Button>
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleSubmit()}
                      >
                        {t(DispensingLanguage[lan][menukey]["Save"])}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/location-entry")}
                      >
                        {t(DispensingLanguage[lan][menukey]["Cancel"])}
                      </Button>
                    </Grid>
                  ) : (
                    <Grid item xs={12} className="mt-2 text-center">
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleUpdate()}
                      >
                        {t(DispensingLanguage[lan][menukey]["update"])}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/location-entry")}
                      >
                        {t(DispensingLanguage[lan][menukey]["Cancel"])}
                      </Button>
                    </Grid>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <Card className="sw_card">
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.LocationName}
                  helperText={errorObject.LocationName}
                  required
                  id="LocationName"
                  name="LocationName"
                  label={DispensingLanguage[lan][menukey]["Location Name"]}
                  value={formData.LocationName}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>

              <Grid item xs={4} sm={4}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.ContactName}
                  helperText={errorObject.ContactName}
                  id="ContactName"
                  name="ContactName"
                  label={DispensingLanguage[lan][menukey]["Contact Name"]}
                  value={formData.ContactName}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.ContactNo}
                  helperText={errorObject.ContactNo}
                  required
                  id="ContactNo"
                  name="ContactNo"
                  label={DispensingLanguage[lan][menukey]["Contact No"]}
                  value={formData.ContactNo}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              <Grid item xs={4} sm={4} className="marginBottom20">
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.Email}
                  helperText={errorObject.Email}
                  id="Email"
                  name="Email"
                  label={DispensingLanguage[lan][menukey]["Email"]}
                  value={formData.Email}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              <Grid item xs={4} sm={4} className="marginBottom20">
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.LocationsAddress}
                  helperText={errorObject.LocationsAddress}
                  id="LocationsAddress"
                  name="LocationsAddress"
                  label={DispensingLanguage[lan][menukey]["Location Address"]}
                  value={formData.LocationsAddress}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
            </Grid>

            {/* New Row */}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LocationFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
